import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

import { roundedComponentVariants } from 'constants/components';
import ColorButton from 'components/simple/ColorButton';
import { CrossIcon as CloseIcon } from 'assets/icons';

const styles = {
  box: ({ palette }) => ({
    borderRadius: '20px',
    paddingBlock: 1,
    paddingLeft: 3,
    paddingRight: 7,
    backgroundColor: palette.primary.main,
    marginTop: 1,
    marginBottom: 3,
    position: 'relative',
  }),
  closeButton: ({ palette }) => ({
    backgroundColor: `${palette.common.white} !important`,
    width: '40px !important',
    height: '40px !important',
    position: 'absolute',
    top: 4,
    right: 4,
    '&.MuiIconButton-root': {
      padding: 1,
    },
  }),
};

const MaintenanceWarning = ({ onCloseMaintenanceWarning }) => (
  <Box sx={styles.box}>
    <Typography variant="subtitle1-bold" component="p" color="text.secondary">
      {`We have planned platform maintenance between 7am to 9am on 6.09.2024. Please note our services won't be accessible during this time.`}
    </Typography>

    <ColorButton
      transparent
      color="primary"
      icon={CloseIcon}
      variant={roundedComponentVariants.rounded}
      customStyles={styles.closeButton}
      onClick={onCloseMaintenanceWarning}
    />
  </Box>
);

MaintenanceWarning.propTypes = {
  onCloseMaintenanceWarning: PropTypes.func.isRequired,
};

export default MaintenanceWarning;
